import PWA_CONSTANT from '../../../static/country-constant.json';
import PWA_SEO from '../../../static/seo.json';

export const {
  COUNTRY_CODE,
  PHONE_DIGIT,
  CURRENCY_SYMBOL,
  CURRENCY_CODE,
  BLOCKED_PATHS,
  GOOGLE_MAP_COUNTRY,
  DEFAULT_STORE,
  TNC,
  TNC_URL,
  DEFAULT_TNC_URL,
  SHOW_LOAGIN_WITH_PASSWORD,
  DEFAULT_MENU,
  GOOGLE_SITE_VERIFICATION_ID,
  HELP_DESK_NO
} = PWA_CONSTANT;

export const SEODATA = PWA_SEO;
export const PHONE_PLACEHOLDER = PHONE_DIGIT === 9 ? 'XXXXXXXX' : 'XXXXXXXXXX';
export const CURRENCY_STYLE = CURRENCY_CODE.toLowerCase();
export const IS_INDIA = CURRENCY_CODE === 'INR';
export const IS_SL = CURRENCY_CODE === 'LKR';
export const IS_BG = CURRENCY_CODE === 'BDT';
export const IS_WALLET_BLOCKED = IS_SL;
export const MAP_COUNTRY = GOOGLE_MAP_COUNTRY;
export const DEFAULT_STORE_ID_SERVER_VAL = DEFAULT_STORE;

export const MINIAPP = {
    PAYTM: 'PAYTM',
    GPAY: 'GPAY'
};
